import { ClosedDay } from "./closed-day";
import { OpeningHour } from "./opening-hour";
import { ProductDetails } from "./product-details";
import { SelectedProduct } from "./selected-product";
import { KeyValueDataRequest } from "../key-value-data-request";

export class PrivateLocatioDetails {
    openingHours!: OpeningHour[]
    closedDays!: ClosedDay[]
    selectedProducts!: SelectedProduct[]
    products!: ProductDetails[]
    keyValueData!: KeyValueDataRequest[]
  }
  



  

  


  

  

  